import React from "react";
import { Modal, Button, Row, Col, Card } from "react-bootstrap";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHospital, faUsers, faFileMedicalAlt, faChartPie, faCalendarAlt, faMapMarkerAlt, faListUl, faFileExcel, faEye, faGlasses, faSyncAlt, faStethoscope, faLowVision, faHeartbeat, faQuestionCircle, faExclamationTriangle, faClock, faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from "../../styles/Modal.module.css";

const generateExcel = (report, totalPatients) => {
  const data = [
    ['Camp Screening Report'],
    [],
    ['Camp Date', report.campDate ? new Date(report.campDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : 'N/A'],
    ['Location', report.campLocation || 'N/A'],
    [],
    ['Screening Results', 'Count'],
    ['Suspect Cases', report.suspectCount || 0],
    ['Presbyopia', report.presbyopiaCount || 0],
    ['Power to Power', report.powerToPowerCount || 0],
    ['Cataract Surgery Referral', report.cataractSurgeryReferralCount || 0],
    ['Glaucoma (Diagnosed)', report.glaucomaDiagnosedCount || 0],
    ['Glaucoma (Suspected)', report.glaucomaSuspectedCount || 0],
    ['DR Referral', report.drReferralCount || 0],
    ['Other Issues', report.otherIssueCount || 0],
    ['Presbyopia Spectacles', report.presboypiaSpectsCount || 0],
    [],
    ['Total Patients Screened', report.suspectCount || 0],
    [],
    ['Report Generated On', new Date().toLocaleString()]
  ];

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(data);
  ws['!cols'] = [{wch: 30}, {wch: 15}];
  XLSX.utils.book_append_sheet(wb, ws, 'Screening Report');

  const fileName = `Camp_Report_${report.campDate ? new Date(report.campDate).toISOString().split('T')[0] : 'report'}.xlsx`;
  XLSX.writeFile(wb, fileName);
};

export default function CampReportModal({ show, onClose, report, camp }) {
  if (!report) return null; 

  const handleDownload = () => {
    generateExcel(report, report.suspectCount);
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="xl"
      centered
      className={`${styles.modal} report-modal`}
      backdrop="static"
    >
      <div className={styles.modalForm} style={{ border: '2px solid #083270' }}>
        <Modal.Header closeButton closeVariant="white" style={{ backgroundColor: '#083270' }} className={`${styles.modalHeader} text-white`}>
          <Modal.Title className={styles.modalTitle} style={{ color: 'white' }}>
            <FontAwesomeIcon icon={faFileMedicalAlt} className="me-2" />
            Camp Screening Report
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className={styles.modalBody} style={{ padding: '1.5rem' }}>
          {/* Summary Card */}
          <Card className="mb-4" style={{ borderTop: '3px solid #083270' }}>
          <Card.Header className="bg-light">
    <Row className="align-items-center">
      <Col>
        <h5 className="mb-0" style={{ color: '#083270' }}>
          Summary
        </h5>
      </Col>
      <Col className="text-end">
        <span className="badge bg-primary">
          <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
          {report.campDate
            ? new Date(report.campDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "N/A"}
        </span>
      </Col>
    </Row>
  </Card.Header>
  <Card.Body>
    <Row className="align-items-center">
      {/* LEFT SIDE INFO */}
      <Col md={8}>
        <p className="mb-3">
          <strong>
            <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2 text-success" />
            Location:
          </strong>
          <span className="ms-2">{report.campLocation || "N/A"}</span>
        </p>

        <p className="mb-3">
          <strong>
            {/* <FontAwesomeIcon icon={faHospital} className="me-2 text-warning" /> */}
            Taluk:
          </strong>
          <span className="ms-2">{camp.ashaBlockDetails.phcDetails.talukDetails?.taluk || "N/A"}</span>
        </p>

        <p className="mb-3">
          <strong>
            {/* <FontAwesomeIcon icon={faHospital} className="me-2 text-warning" /> */}
            PHC:
          </strong>
          <span className="ms-2">{camp.ashaBlockDetails.phcDetails?.phc || "N/A"}</span>
        </p>

        <p className="mb-0">
          <strong>
            {/* <FontAwesomeIcon icon={faUsers} className="me-2 text-info" /> */}
            Asha Block:
          </strong>
          <span className="ms-2">{camp.ashaBlockDetails?.ashaBlock || "N/A"}</span>
        </p>
      </Col>

      {/* RIGHT SIDE TOTAL PATIENTS */}
      <Col md={4} className="text-end">
        <Card
          className="border-0"
          style={{
            backgroundColor: "#f8f9fa",
            boxShadow: "0 0.5rem 1rem rgba(8, 50, 112, 0.15)",
          }}
        >
          <Card.Body className="py-3">
            <h3 className="mb-0 text-center" style={{ color: "#083270" }}>
              {report.suspectCount}
            </h3>
            <small className="text-dark fw-medium d-block text-center">
              No. of Suspects Examined
            </small>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Card.Body>
</Card>


          {/* Detailed Report */}
          <Row className="align-items-center">
            <Col>
              <h5 className="mb-0" style={{ color: '#083270' }}>
                <FontAwesomeIcon icon={faListUl} className="me-2" />
                Detailed Screening Results
              </h5>
            </Col>
            <Col xs="auto">
              <Button variant="outline-primary" onClick={handleDownload} className="me-2">
                <FontAwesomeIcon icon={faFileExcel} className="me-1" />
                Download Excel
              </Button>
            </Col>
          </Row>

          <Row className="g-4">
            <Col md={6}>
              <Card className="h-100 border-0 shadow-sm" style={{ borderTop: '3px solid #083270' }}>
                <Card.Body>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span><FontAwesomeIcon icon={faEye} className="me-2 text-danger" />Detected with Presbyopia</span>
                      <span className="badge rounded-pill" style={{ backgroundColor: '#083270' }}>{report.presbyopiaCount || 0}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span><FontAwesomeIcon icon={faGlasses} className="me-2 text-success" />Spectacles distributed (Presbyopia) </span>
                      <span className="badge rounded-pill" style={{ backgroundColor: '#083270' }}>{report.presboypiaSpectsCount || 0}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span><FontAwesomeIcon icon={faSyncAlt} className="me-2 text-warning" />Detected with Power to Power</span>
                      <span className="badge rounded-pill" style={{ backgroundColor: '#083270' }}>{report.powerToPowerCount || 0}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span><FontAwesomeIcon icon={faStethoscope} className="me-2 text-danger" />Suspected with DR (Referred to Hospital)</span>
                      <span className="badge rounded-pill" style={{ backgroundColor: '#083270' }}>{report.drReferralCount || 0}</span>
                    </li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="h-100 border-0 shadow-sm" style={{ borderTop: '3px solid #083270' }}>
                <Card.Body>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span><FontAwesomeIcon icon={faLowVision} className="me-2 text-danger" />Detected with Cataract (Referred for Surgery)</span>
                      <span className="badge shadow-lg rounded-pill" style={{ backgroundColor: '#083270' }}>{report.cataractSurgeryReferralCount || 0}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span><FontAwesomeIcon icon={faHeartbeat} className="me-2 text-warning" />Detected with Glaucoma (Rx Started)</span>
                      <span className="badge rounded-pill" style={{ backgroundColor: '#083270' }}>{report.glaucomaDiagnosedCount || 0}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span><FontAwesomeIcon icon={faQuestionCircle} className="me-2 text-danger" />Suspected with Glaucoma (Referred to Hospital)</span>
                      <span className="badge rounded-pill" style={{ backgroundColor: '#083270' }}>{report.glaucomaSuspectedCount || 0}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span><FontAwesomeIcon icon={faExclamationTriangle} className="me-2 text-danger" />Detected with Other Conditions</span>
                      <span className="badge rounded-pill" style={{ backgroundColor: '#083270' }}>{report.otherIssueCount || 0}</span>
                    </li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className={`${styles.modalFooter} bg-light`}>
          <small className="text-muted me-auto">
            <FontAwesomeIcon icon={faClock} className="me-1" />
            Generated on: {new Date().toLocaleString()}
          </small>

          <Button variant="danger" onClick={onClose} className="px-4">
            <FontAwesomeIcon icon={faTimes} className="me-1" />
            Close
          </Button>
        </Modal.Footer>
      </div>

      <style jsx>{`
        .report-modal .modal-content {
          border: none;
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
          border: 2px solid #083270;
        }
        .report-modal .card {
          transition: transform 0.2s;
        }
        .report-modal .card:hover {
          transform: translateY(-2px);
        }
        .report-modal .badge {
          font-weight: 500;
          padding: 0.4em 0.8em;
        }
      `}</style>
    </Modal>
  );
}
